import {
    IonCard,
    IonCardHeader,
    IonContent,
    IonPage,
    IonRow,
} from '@ionic/react';
import { IonIcon } from '@ionic/react';
import { copyOutline } from 'ionicons/icons';
import Logo from '../logo/Logo';
import generatedGitInfo from '../../generatedGitInfo.json';


const NocVersionInfo = () => {

    const handleCopy = (textToCopy: string) => {
        navigator.clipboard.writeText(textToCopy)
        .catch((err) => {
            console.error("Unable to copy:", err);
        });
    };
   
    return (
        <IonPage>
            <IonContent>
                <IonCard>
                    <IonCardHeader>
                        <IonRow className="ion-justify-content-center">
                            <Logo />
                        </IonRow>
                        <p>
                            <strong>Git Branch:</strong>{' '}
                            <code>{generatedGitInfo.gitBranch}</code>
                        </p>
                        <p>
                            <strong>Git Commit Hash:</strong>{' '}
                            <code>
                                {generatedGitInfo.gitCommitHash}
                                <IonIcon
                                    icon={copyOutline}
                                    onClick={() => handleCopy(generatedGitInfo.gitCommitHash)}
                                    style={{ cursor: 'pointer', marginLeft: '5px' }}
                                />
                            </code>
                        </p>
                        <p>
                            <strong>Git Commit Date:</strong>{' '}
                            <code>{generatedGitInfo.gitCommitDate}</code>
                        </p>
                    </IonCardHeader>
                </IonCard>
            </IonContent>
        </IonPage>
    );
};

export default NocVersionInfo;
